import { useCountdownTimer } from '@nesso/ui/hooks/use-countdown-timer';

type Props = {
    deadlineAt: number;
    onFinish: () => void;
};

export function SignInWithPasswordCooldownCountdown({ deadlineAt, onFinish }: Props) {
    const { remaining } = useCountdownTimer({ deadlineAt, onFinish });
    const seconds = Math.ceil(remaining / 1000);

    return (
        <p
            className="text-center text-base font-medium leading-none text-foreground"
            aria-live="polite"
        >
            Try again in {seconds}s
        </p>
    );
}
